import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide, Carousel as DSCarousel } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./carousel.module.css";
import { VehicleCard } from "../cards/cards";
export const Carousel = ({ carouselName , vehicles  })=>{
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DSCarousel, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    }
                },
                ariaLabel: `${carouselName}-carousel`,
                children: vehicles.map((vehicle)=>!vehicle.isReserved && vehicle.isAvailable && /*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _jsx(VehicleCard, {
                            vehicle: vehicle,
                            carouselName: "latest-cars"
                        })
                    }, vehicle.vehicleId))
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles.controlsWrapper,
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselName,
                        className: cx(`${carouselName}-pagination`, styles.pagination, styles.customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: styles.prevButton,
                            nextButton: styles.nextButton
                        }
                    })
                ]
            })
        ]
    });
};
